export type AudioPropsType = {
  src: string;
  caption?: string;
  noDownload?: boolean;
};

function Audio({ src, caption, noDownload = false }: AudioPropsType) {
  return (
    <figure className='flex flex-col items-center justify-center gap-2'>
      {caption && <figcaption className='font-medium'>{caption}</figcaption>}
      <audio controls src={src} {...(noDownload ? { controlsList: 'nodownload' } : {})}>
        Your browser does not support the
        <code>audio</code> element.
      </audio>
    </figure>
  );
}

export default Audio;
